import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IState } from "src/models/General/State.models";

interface StateState {
  states: IState[];
  stateToEdit: IState | null;
}

const initialState: StateState = {
  states: [],
  stateToEdit: null,
};

const stateSlice = createSlice({
  name: "State",
  initialState,
  reducers: {
    setStateList: (state, action: PayloadAction<IState[]>) => {
      state.states = action.payload;
    },
    concatListState: (state: StateState, action: PayloadAction<IState[]>) => {
      state.states = [...state.states.concat(action.payload)];
    },
    setStateToEdit: (state, action: PayloadAction<IState | null>) => {
      state.stateToEdit = action.payload;
    },
    addState: (state, action: PayloadAction<IState>) => {
      state.states.push(action.payload);
    },
    updateState: (state, action: PayloadAction<IState>) => {
      let itemIndex = state.states.findIndex(
        item => item.stateId === action.payload.stateId
      );
      if (itemIndex !== -1) state.states[itemIndex] = action.payload;
    },
    deleteState: (state, action: PayloadAction<number>) => {
      const newArray = state.states.filter(
        item => item.stateId !== action.payload
      );
      state.states = newArray;
    },
  },
});

export const {
  setStateList,
  concatListState,
  setStateToEdit,
  addState,
  updateState,
  deleteState,
} = stateSlice.actions;

export default stateSlice.reducer;
